import { useTranslations } from '@vocab/react';
import { Button, ButtonLink, Stack, Text } from 'braid-design-system';
import React, { useCallback, useEffect } from 'react';

import { useGetShareableProfileStatus } from 'src/components/Profile/ProfileVisibilityV2/data';
import { useAnalytics } from 'src/modules/analytics/AnalyticsProvider';

import translations from './.vocab';
import { ReadyIllustration } from './illustration/ReadyIllustration';

export const Ready = ({ copyLinkFn }: { copyLinkFn: () => void }) => {
  const { t } = useTranslations(translations);
  const { shareableProfileUrl } = useGetShareableProfileStatus();
  const { shareableProfileShareViewed, shareableProfileShareLinkClicked } =
    useAnalytics();

  useEffect(() => {
    shareableProfileShareViewed({
      eventName: 'profile_section_displayed',
      currentPage: 'profile visibility shared profile lite consent',
      profileSharedStatus: 'on',
    });
    // run once during on load only
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const sendTrackingLinkEvent = useCallback(
    (eventName: 'profile_link_copy_pressed' | 'profile_link_open_pressed') => {
      shareableProfileShareLinkClicked({
        eventName,
        currentPage: 'profile visibility shared profile lite consent',
        actionOrigin: 'profile',
        profileSharedStatus: 'on',
      });
    },
    [shareableProfileShareLinkClicked],
  );

  return (
    <>
      <ReadyIllustration />
      <Stack space="large">
        <Text tone="secondary">{t('Share to employers and peers by...')}</Text>
        <Stack space="small">
          <Button
            id="copy-link-btn"
            tone="formAccent"
            data={{ automation: 'copy-link-btn' }}
            onClick={() => {
              sendTrackingLinkEvent('profile_link_copy_pressed');
              copyLinkFn();
            }}
          >
            {t('Copy link')}
          </Button>
          <ButtonLink
            id="preview-btn"
            data={{ automation: 'preview-btn' }}
            href={shareableProfileUrl || ''}
            target="_blank"
            tone="formAccent"
            variant="transparent"
            onClick={() => {
              sendTrackingLinkEvent('profile_link_open_pressed');
            }}
          >
            {t('Preview')}
          </ButtonLink>
        </Stack>
      </Stack>
    </>
  );
};
